import * as React from "react"
import { motion, useInView, useMotionValueEvent, useScroll, useTransform } from "framer-motion"
import { Link } from "react-router-dom"
interface HeroProps {
	type?: any
}

const Hero: React.FC<HeroProps> = ({ type = "" }) => {
	return (
		<>
			{type === "promoover" ? (
				<section className=" mx-auto max-w-[1800px] bg-white pt-[44px] md:pt-[70px] mt-[3.4rem] md:-mt-[2rem] lg:-mt-[2rem] xl:-mt-[3rem] 2xl:-mt-[4rem] relative">
					<img src={process.env.PUBLIC_URL + "/images/alpro/hero-desktop.png"} className="relative mx-auto hidden md:block" />
					<img src={process.env.PUBLIC_URL + "/images/alpro/hero-mobile.png"} className="relative mx-auto block  md:hidden" />
					<div className="relative -top-[99px]  ml-[9%] md:top-[75px] md:ml-0 md:text-center"></div>
				</section>
			) : type === "winner" ? (
				<section className=" mx-auto max-w-[1800px] bg-white  md:-mt-[30px]">
					<img src={process.env.PUBLIC_URL + "/images/alpro/winner-page-bg.png"} className="relative mt-24 mx-auto hidden md:block" />
					<img src={process.env.PUBLIC_URL + "/images/alpro/winner-page-bg-mobile.png"} className=" mt-24 md:mt-0 relative mx-auto block  md:hidden" />
					<div className="relative -top-[99px]  ml-[9%] md:top-[75px] md:ml-0 md:text-center"></div>
				</section>
			) : (
				<section className=" mx-auto max-w-[1800px] bg-white pt-[44px] md:pt-[70px] mt-[3.4rem] md:-mt-[2rem] lg:-mt-[2rem] xl:-mt-[3rem] 2xl:-mt-[4rem] relative">
					<img src={process.env.PUBLIC_URL + "/images/alpro/hero-desktop.png"} className="relative mx-auto hidden md:block" />
					<img src={process.env.PUBLIC_URL + "/images/alpro/hero-mobile.png"} className="relative mx-auto block  md:hidden " />
					<div className="absolute bottom-[35%] left-[5%] md:bottom-[12%] lg:bottom-[15%] xl:bottom-[18%] 2xl:bottom-[20%] md:left-[17%] lg:left-[20%]">
						<a
							href="#teilnehmen"
							className="mb-6 mt-12 block w-[100%] bg-blue py-2 px-4 md:p-4 font-Alpro text-[22px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[24px] xl:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block  md:py-1 lg:py-2 lg:px-6"
						>
							Hier Teilnehmen
						</a>
					</div>
				</section>
			)}
		</>
	)
}

export default Hero
